import React from "react";
import PropTypes from "prop-types";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { ShareLinkedIn, ShareTwitter } from "../Share";
import Svg from "../Svg";
import ActionButton from "../ActionButton";
import PartnerLogo from "../PartnerLogo";

import styles from "./index.module.css";
import copylink from "./copylink.svg";
import ArrowSponsors from "./Arrow_Sponsors.svg";
import { graphql, StaticQuery } from "gatsby";
import SoetLogo from "../../assets/report-logo-dark.svg";
import AtomicoLogo from "../../assets/data-partner-logos/atomico-dark.svg";
import SlushLogo from "../../assets/data-partner-logos/slush-dark.svg";
import OrrickLogo from "../../assets/data-partner-logos/orrick-dark.svg";
import SvbLogo from "../../assets/data-partner-logos/svb-dark.svg";
import BgLogo from "../../assets/data-partner-logos/bg-dark.svg";

const WatermarkSeparator = () => <div className={styles.watermarkSeparator} />;

class FigureFooterWithoutStaticQuery extends React.Component {
  /* ReportNav lives higher up the component tree, here we just have styles
     on .contentWrapper that leaves space for it
  */
  constructor(props) {
    super(props);
    this.state = {
      value: ``,
      copied: false
    };
  }

  render() {
    const {
      onDownloadClick,
      showWatermark,
      sources,
      title,
      siteUrl,
      sponsorLabel,
      sponsorUrl,
      sharePath
    } = this.props;

    const linkedinText = title;
    const twitterText = title;
    const shareUrl = `${siteUrl}${sharePath}`;
    return (
      <div className={styles.rootContainer}>
        <div className={styles.root}>
          {sources && sources.length > 0 && (
            <h4 className={styles.source}>
              <span className={styles.term}>Source</span>
              <div className={styles.vline}></div>
              {sources.map(source => (
                <PartnerLogo key={source} partner={source} white={false} />
              ))}
            </h4>
          )}
          {onDownloadClick && (
            <div className={styles.section}>
              <div className={styles.button}>
                <ActionButton onClick={onDownloadClick} />
              </div>
              <div className={styles.socialAction}>
                <CopyToClipboard
                  text={shareUrl}
                  onCopy={() => this.setState({ copied: true })}
                >
                  <a className={styles.rootCopy}>
                    <Svg className={styles.icon} svg={copylink} />
                  </a>
                </CopyToClipboard>
              </div>
              <div className={styles.social}>
                <div className={styles.socialAction}>
                  <ShareTwitter text={twitterText} url={shareUrl} />
                </div>
                <div className={styles.socialAction}>
                  <ShareLinkedIn
                    url={shareUrl}
                    sourceUrl={shareUrl}
                    title={linkedinText}
                  />
                </div>
              </div>
            </div>
          )}
          {showWatermark && (
            <div className={styles.watermark}>
              <SoetLogo style={{height: `36px`, marginRight: `-10px`, marginTop: `-6px`, marginBottom: `-6px`}} />
              <div className={styles.vlineWatermark} />
              <AtomicoLogo />
              <div className={styles.vlineWatermark} />
              <SlushLogo />
              <div className={styles.vlineWatermark} />
              <OrrickLogo />
              <div className={styles.vlineWatermark} />
              <SvbLogo />
              <div className={styles.vlineWatermark} />
              <BgLogo />
            </div>
          )}
        </div>
        {sponsorLabel && sponsorUrl && (
          <div className={styles.sponsor}>
            {sponsorLabel}
            <a
              className={styles.sponsorLink}
              href={sponsorUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Svg className={styles.sponsorLinkIcon} svg={ArrowSponsors} />
            </a>
          </div>
        )}
      </div>
    );
  }
}

export default props => (
  <StaticQuery
    query={graphql`
      {
        site {
          siteMetadata {
            siteUrl: url
          }
        }
      }
    `}
    render={data => (
      <FigureFooterWithoutStaticQuery
        siteUrl={data.site.siteMetadata.siteUrl}
        {...props}
      />
    )}
  />
);

FigureFooterWithoutStaticQuery.propTypes = {
  insight: PropTypes.string,
  onDownloadClick: PropTypes.func,
  showWatermark: PropTypes.bool,
  sources: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
  siteUrl: PropTypes.string,
  sponsorLabel: PropTypes.string,
  sponsorUrl: PropTypes.string
};
